import { render, staticRenderFns } from "./CenterExamSummary.vue?vue&type=template&id=35045e9d&"
import script from "./CenterExamSummary.vue?vue&type=script&lang=js&"
export * from "./CenterExamSummary.vue?vue&type=script&lang=js&"
import style0 from "./CenterExamSummary.vue?vue&type=style&index=0&id=35045e9d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports